import $axios from './apiConnection'
import parseCatch from '@/helpers/handleErrors'

const SUCCESS_STATUS = 'OK'

export const WidgetApi = {
    async find(id, requestConfig = {}) {
        try {
            return await $axios.get(`/Widgets/Get/${id}`, requestConfig)
        } catch (e) {
            parseCatch(e, true, 'Find Widget')
        }
    },
    async update(data, requestConfig = {}) {
        try {
            if (!data.WidgetTime) {
                data.WidgetTime = {}
            }
            if (data.Order === null) {
                data.Order = 0
            }

            if (!data.WidgetConfig) {
                data.WidgetConfig = []
            } else {
                data.WidgetConfig = data.WidgetConfig.filter(config => config.ParameterID)
            }

            let result = await $axios.post(`/Widgets/Update/`, data, requestConfig)
            return parseCustomErrorMessage(result, 'Update Widget')
        } catch (e) {
            parseCatch(e, true, 'Update Widget')
        }
    },
    async updatePosition(data, requestConfig = {}) {
        try {
            const widgetList = {
                WidgetList: data
            }
            let result = await $axios.post(`/Widgets/UpdatePosition/`, widgetList, requestConfig)
            return parseCustomErrorMessage(result, 'Update Widget Position')
        } catch (e) {
            parseCatch(e, true, 'Update Widget')
        }
    },

    async store(data, requestConfig = {}) {
        try {
            if (!data.WidgetConfig) {
                data.WidgetConfig = []
            }
            let result = await $axios.post('/Widgets/Add/', data, requestConfig)
            return parseCustomErrorMessage(result, 'Add Widget')
        } catch (e) {
            parseCatch(e, true, 'Add Widget')
        }
    },

    updateStatus(widgetId, widgetStatus, requestConfig = {}) {
        return $axios.post(`/Widgets/UpdateStatus/${widgetId}/${widgetStatus}`, requestConfig)
    },

    destroy(widgetId, requestConfig = {}) {
        return $axios.get(`/Widgets/Delete/${widgetId}`, requestConfig)
    },
    async getAllWidgetsByAccountId (accountId, requestConfig = {}) {
        try {
            const { Data} = await $axios.get(`/DashBoards/DashboardWidgetsAccountID/${accountId}`, requestConfig)
            return Data
        } catch (e) {
            parseCatch(e, true, 'Get All Widgets')
        }
    }
}

function parseCustomErrorMessage(result, prefixMessage) {
    if (typeof result === 'string' && result !== SUCCESS_STATUS) {
        let apiError = { message: result }
        parseCatch(apiError, true, prefixMessage)
    }
    return result
}
